import { Component, HostBinding, Input } from '@angular/core';

/**
 * Moldura de altura fixa para gráficos do Chart.js com `maintainAspectRatio: false`.
 * Sem um contêiner de altura definida, o canvas realimenta a altura do próprio pai e o card cresce a cada resize.
 * Fica oculta quando o canvas não é renderizado (ex.: `*ngIf` sem dados).
 */
@Component({
  selector: 'ss-chart-frame',
  template: '<ng-content></ng-content>',
  styles: [`
    :host { display: block; position: relative; width: 100%; min-height: 0; overflow: hidden; }
    :host:empty { display: none; }
  `],
  standalone: false
})
export class ChartFrameComponent {
  /** Número (px) ou valor CSS, como `100%` quando o pai já tem altura definida. */
  @Input() height: number | string = 250;

  @HostBinding('style.height') get frameHeight(): string { return typeof this.height === 'number' ? `${this.height}px` : this.height; }
}
